import * as React from 'react';
import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid, TextField, EditButton, BooleanField, useNotify,
    useDelete, ListProps, Button as RAButton,
    useRecordContext, TextInput
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ISubCategory } from '../types/types';
import useAdmin from '../hooks/useAdmin';
import { ALL_CATEGORIES_FILTER } from '../utils/materialTypeFilters';

const subCategoryFilters = [
    <TextInput key="subcategory-search" label="Search" source="subcategory_search" resettable alwaysOn />,
];

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<ISubCategory>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('subcategories', { id: record.id });
        notify('resources.subcategories.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'SubCategory' }
        });
        setOpen(false);
    };
    useAdmin();
    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this sub category?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export const SubCategoryList: FC<ListProps> = (props) => {
    return (
        <List
            {...props}
            filters={subCategoryFilters}
            filter={ALL_CATEGORIES_FILTER}
            filterDefaultValues={ALL_CATEGORIES_FILTER}
            perPage={25}
            sort={{ field: 'category_name', order: 'ASC' }}
        >
            <Datagrid>
                <TextField source="category_name" label="Category" sortable />
                <TextField source="sub_category_name" label="Sub Category" sortable />
                <TextField source="sub_category_description" label="Description" sortable />
                <BooleanField source="is_virgin" label="Virgin" sortable />
                <BooleanField source="is_reprocessed" label="Reprocessed" sortable />
                <EditButton />
                <DeleteWithConfirmButton />
            </Datagrid>
        </List>
    );
};